import { Typography } from "@otp/ui";
import { StoreModel } from "src/graphql/generated/graphql";
import { getAddress } from "src/utils/restaurant-data";

export const RestaurantAddress = ({
  restaurant,
}: {
  restaurant: Partial<StoreModel>;
}) => {
  return (
    <div>
      <Typography fontWeight="bold" variant="subtitle1" component="div">
        {restaurant.name}
      </Typography>
      <Typography variant="subtitle2" component="div">
        {getAddress(restaurant)}
      </Typography>
    </div>
  );
};
